import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SigningLawSectionDropdownComponent } from './signing-law-section-dropdown.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { LoaUiLawSectionStatusComponent } from '../ui/loa-ui-law-section-status/loa-ui-law-section-status.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [SigningLawSectionDropdownComponent],
  exports: [SigningLawSectionDropdownComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    LoaUiLawSectionStatusComponent,
    NgSelectModule,
  ],
})
export class SigningLawSectionDropdownModule {}
